// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => ({"303":"widget","614":"skin-wide-with-summary"}[chunkId] + ".css");